<template>
    <div>
        <app-card
            headerIcon="autorenew"
            :heading="$t('lang.Subscriptions')"
            colClasses=""
            customClasses="mb-0"
            :fullBlock="true"
            :fullScreen="true"
            :reloadable="true"
            :closeable="true"
            :footer="true"
            :reload="reload"
        >
            <recent-sale></recent-sale>
            <v-spacer slot="footer"></v-spacer>
            <v-btn
                v-if="doesNotHaveLoginType(['csr', 'producer', 'dispatcher', 'technician', 'driver', 'dispenser_mgr', 'customer', 'customer_readonly'])"
                slot="footer"
                color="primary"
                @click="$router.push({ name: 'subscriptions' })"
                small
                >{{ $t("lang.view_all") }}</v-btn
            >
            <v-btn slot="header" icon small @click="refreshSubscriptions"><v-icon>refresh</v-icon></v-btn>
        </app-card>
    </div>
</template>
<script>
import RecentSale from "App_components/Widgets/Subscriptions.vue";
import { mapActions, mapState } from "vuex";
export default {
    components: {
        RecentSale,
    },
    data() {
        return {
            name: "subscriptions",
            reload: false,
        };
    },
    computed: {
        ...mapState({
            subscriptions: (state) => state.subscriptions.subscription_options,
            company_options: (state) => state.companies.company_options,
        }),
    },
    methods: {
        ...mapActions(["fetchCompanies", "fetchSubscriptions"]),
        async refreshSubscriptions(refresh = false) {
            this.reload = true;
            this.$store.commit("mutate", {
                property: "subscription_options",
                with: [],
            });
            this.fetchSubscriptions({ body: { billable: "1", options: "1" } }).then((data) => {
                this.reload = false;
            });
        },
    },
};
</script>
